import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';

@Component({
  selector: 'dl-notification-title',
  templateUrl: './notification-title.component.html',
  styleUrls: ['./notification-title.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationTitleComponent implements OnInit, OnDestroy {

  constructor(private _QnSbnDataService:QnSbnDataService) { }
  
  public notificationTitleformctrl = new FormControl('Rajesh', [Validators.minLength(3), Validators.maxLength(256)]);
  public localNotificationData: any;
  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(!this._QnSbnDataService.isEmpty(observer['localNotificationId'])){
        this.localNotificationData = observer['localNotificationId'];
        this.notificationTitleformctrl.setValue(observer['localNotificationId']['Title']);
      }
    })
  }
  ngDoCheck() {
    // console.log('in do check-->',this._QnSbnDataService.storageForQnsbn);
    this.addProduct(this.notificationTitleformctrl.value);
  }
  ngOnDestroy(): void {
    this.addProduct(this.notificationTitleformctrl.value);
  }

  public addProduct(title) {
    this.localNotificationData['Title'] = title;
    this._QnSbnDataService.getMappedQnsbnData(this.localNotificationData,"LocalNotificationId");
  }
}
